module.exports = __webpack_public_path__ + "img/logo.2058151.webp";